import React, { useContext } from "react";
import { SettingsContext } from "./SettingsLayout";
import ClientSettings from "./ClientSettings";
import ExportSettings from "./ExportSettings";
import FiskalyDashboard from "./FiskalyDashboard";
import TSSSettings from "./TSSSettings";
import TransactionSettings from "./TransactionSettings";

const SettingsContent: React.FC = React.memo(() => {
  const { activeSection } = useContext(SettingsContext);

  // Render the appropriate content based on active section
  // Using a switch to ensure only one component is rendered at a time
  const renderContent = () => {
    switch (activeSection) {
      case "TSS":
        return <TSSSettings />;
      case "Client":
        return <ClientSettings />;
      case "Transactions":
        return <TransactionSettings />;
      case "Export":
        return <ExportSettings />;
      case "Dashboard":
        return <FiskalyDashboard />;
      default:
        return <TSSSettings />; // Default to TSS if unknown section
    }
  };

  return <>{renderContent()}</>;
});

SettingsContent.displayName = "SettingsContent";

export default SettingsContent;
